@if ((activeStepIndex$ | async) !== undefined) {
  <div>
    <div class="cx-media">
      @for (step of steps$ | async; track step; let i = $index) {
        <div>
          @if (i > activeStepIndex) {
            <div class="cx-list-media">
              <div>{{ step.name | cxTranslate }}</div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
